import { render, staticRenderFns } from "./CobranzaIncapacidadAP.vue?vue&type=template&id=2ad3fc55"
import script from "./CobranzaIncapacidadAP.vue?vue&type=script&lang=js"
export * from "./CobranzaIncapacidadAP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports